module.exports = __webpack_public_path__ + "img/videoActive.8eac4982.png";